const ACTIONS = {
  FETCH_LATEST_LOGS_INIT: "FETCH_LATEST_LOGS_INIT",
  FETCH_LATEST_LOGS_SUCCESS: "FETCH_LATEST_LOGS_SUCCESS",
  FETCH_LATEST_LOGS_FAILURE: "FETCH_LATEST_LOGS_FAILURE",
};

export default ACTIONS;
